import { addCoreAgentConversationTitlesSyncSlice } from './add';
import { updateCoreAgentConversationTitleSyncSlice } from './update';

export const addCoreAgentConversationTitles = addCoreAgentConversationTitlesSyncSlice.syncActionCreator;
export const updateCoreAgentConversationTitle = updateCoreAgentConversationTitleSyncSlice.syncActionCreator;
